import { FileText } from "lucide-react";

// Parent Dashboard -> "Forms To Complete" card. Extracted from
// ParentDashboard.js (props-driven, no behavior change).
export const FormsToCompleteCard = ({ pendingForms, onOpenForm }) => (
  <section className="rounded-[var(--radius)] border bg-card">
    <div className="p-4 sm:p-5 border-b flex items-center justify-between">
      <h2 className="text-lg font-semibold font-heading flex items-center gap-2">
        <FileText className="h-5 w-5 text-[hsl(var(--role-accent))]" /> Forms To Complete
      </h2>
    </div>
    <div className="divide-y">
      {pendingForms.length === 0 && (
        <p className="p-6 text-sm text-muted-foreground text-center">
          You&apos;re all caught up — every form is signed and on file.
        </p>
      )}
      {pendingForms.map((f) => (
        <button
          key={f.id}
          onClick={() => onOpenForm(f)}
          className="w-full text-left p-4 sm:p-5 hover:bg-accent transition-colors"
          data-testid="parent-pending-form-row"
        >
          <p className="text-sm font-medium">{f.form_title}</p>
          <p className="text-xs text-muted-foreground">Tap to complete & sign</p>
        </button>
      ))}
    </div>
  </section>
);
